import { Controller } from "stimulus";

export default class extends Controller {
  openShowModal(event) {
    event.preventDefault();
    $('#view_completed_report_card').modal();
    $('#view_completed_report_card .modal-body').html('<h3 class="text-center p-5"><i class="fad fa-spinner-third fa-spin d-inline-block text-secondary fa-2x"></i></h3>');

    var modalUrl = $(event.target).data('modalUrl');

    fetch(modalUrl)
      .then(response => response.text())
      .then(function(html){
        $('#view_completed_report_card .modal-body').html(html);

        setTimeout((function() {
          window.loadTimepicker();
          window.loadFlatpickr();
        }), 250);

      });
  }

  openEditModal(event) {
    event.preventDefault();
    $('#edit_completed_report_card').modal();

    $('#edit_completed_report_card .modal-body').html('<h3 class="text-center p-5"><i class="fad fa-spinner-third fa-spin d-inline-block text-secondary fa-2x"></i></h3>');

    var modalUrl = $(event.target).data('modalUrl');

    fetch(modalUrl)
      .then(response => response.text())
      .then(function(html){
        $('#edit_completed_report_card .modal-body').html(html);

        setTimeout((function() {
          window.loadTimepicker();
          window.loadFlatpickr();
        }), 250);
      });
  }

}